import { DateIntegrationProvider } from '@integrations/date-provider'
import { HtmlIntegrationProvider } from '@integrations/html-provider'
import { LoadingIntegrationProvider } from '@integrations/loading-provider'
import { PhoneIntegrationProvider } from '@integrations/phone-provider'
import type { PropsWithChildren } from '@integrations/react'
import { RouterIntegrationProvider } from '@integrations/router-provider'
import { SelectIntegrationProvider } from '@integrations/select-provider'
import { TooltipIntegrationProvider } from '@integrations/tooltip-provider'
import { dateLocales } from '../integration-setup/date-locales'

export function IntegrationProviders({ children }: PropsWithChildren) {
  return (
    <RouterIntegrationProvider>
      <TooltipIntegrationProvider>
        <LoadingIntegrationProvider>
          <PhoneIntegrationProvider>
            <DateIntegrationProvider locales={dateLocales}>
              <SelectIntegrationProvider>
                <HtmlIntegrationProvider>{children}</HtmlIntegrationProvider>
              </SelectIntegrationProvider>
            </DateIntegrationProvider>
          </PhoneIntegrationProvider>
        </LoadingIntegrationProvider>
      </TooltipIntegrationProvider>
    </RouterIntegrationProvider>
  )
}
